import { RootState } from "../../rootState";

export const validFromSelector = (state: RootState) =>
    state.validityInterval.validFrom ? state.validityInterval.validFrom : state.urlParams.effectiveDate;
export const validToSelector = (state: RootState) =>
    state.validityInterval.validTo ? state.validityInterval.validTo : state.urlParams.validTo;
